// src/components/layout/IFoodLayoutWrapper.jsx
import React, { useState } from 'react';
import { Box, CssBaseline, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IFoodSidebar from './IFoodSidebar';
import TopBar from './TopBar';
import IFoodDateFilter from './IFoodDateFilter';
import { Outlet } from 'react-router-dom';

const SIDEBAR_WIDTH_EXPANDED = 260;
const SIDEBAR_WIDTH_COLLAPSED = 72;

export default function IFoodLayoutWrapper() {
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // Initialize sidebar based on screen size so it doesn't pop open on route changes
    const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
    const [collapsed, setCollapsed] = useState(false);

    // Filter visibility logic
    const showFilter = [
        "/faturamento", "/entrada", "/saida", "/dre", "/marketing",
        "/delivery", "/pratos", "/faltas", "/operacional/relatorio",
        "/financeiro/fluxo-caixa"
    ].some((path) => location.pathname.startsWith(path));

    const handleApplyFilter = (payload) => {
        window.dispatchEvent(new CustomEvent("vochica:filters-applied", { detail: payload }));
    };

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
    const toggleCollapse = () => setCollapsed(!collapsed);

    // Calculate dynamic margin based on state
    // On Desktop: If Open -> Use Width (Expanded or Collapsed). If Closed -> 0.
    const sidebarWidth = sidebarOpen ? (collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED) : 0;

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', overflow: 'hidden', width: '100%' }}>
            <CssBaseline />


            {/* Sidebar Component with lifted state */}
            <IFoodSidebar
                open={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                isMobile={isMobile}
                toggleSidebar={toggleSidebar}

                // Collapse Props
                collapsed={collapsed}
                onCollapse={toggleCollapse}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    width: `calc(100% - ${sidebarWidth}px)`,
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    pb: showFilter ? '80px' : 0,
                    transition: 'width 0.3s ease',
                    overflowX: 'hidden',
                }}
            >
                <TopBar onMenuClick={toggleSidebar} />
                <Box sx={{ flexGrow: 1, p: { xs: 2, md: 3 } }}>
                    <Outlet />
                </Box>
            </Box>

            {showFilter && (
                <IFoodDateFilter onApply={handleApplyFilter} />
            )}
        </Box>
    );
}
